import { render, staticRenderFns } from "./product_4_fcw.vue?vue&type=template&id=24626baa&scoped=true"
import script from "./product_4_fcw.vue?vue&type=script&lang=js"
export * from "./product_4_fcw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24626baa",
  null
  
)

export default component.exports